document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll('.newsletter-icons .icons');

  if (!sliders.length) return;

  sliders.forEach(slider => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      this.classList.add('is-dragging');
      startX = e.pageX - this.offsetLeft;
      scrollLeft = this.scrollLeft;
    });

    slider.addEventListener('mouseleave', function () {
      isDown = false;
      this.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseup', function () {
      isDown = false;
      this.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.offsetLeft;
      const walk = (x - startX) * 1.2;
      this.scrollLeft = scrollLeft - walk;
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vantagens-lottie').forEach(function (el) {
    const file = el.dataset.lottie;

    if (!file) return;

    lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `${themeData.themePath}/assets/images/animations/${file}`
    });
  });
});
